const DEFAULT_MAX_EDGE = 1024;
const DEFAULT_QUALITY = 0.78;
const TARGET_MAX_CHARS = 380_000;

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };

    image.src = url;
  });
}

function renderDataUrl(image, maxEdge, quality) {
  const { width, height } = image;
  const scale = Math.min(1, maxEdge / Math.max(width, height));
  const targetW = Math.max(1, Math.round(width * scale));
  const targetH = Math.max(1, Math.round(height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = targetW;
  canvas.height = targetH;

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Canvas not supported");
  }

  ctx.drawImage(image, 0, 0, targetW, targetH);
  return canvas.toDataURL("image/jpeg", quality);
}

/**
 * Resize/compress a File to a JPEG data URL so photos fit in localStorage.
 * Retries with smaller settings when the result is still too large.
 */
export async function compressImageFile(
  file,
  { maxEdge = DEFAULT_MAX_EDGE, quality = DEFAULT_QUALITY } = {},
) {
  const image = await loadImageFromFile(file);

  const attempts = [
    { maxEdge, quality },
    { maxEdge: Math.min(maxEdge, 960), quality: Math.min(quality, 0.72) },
    { maxEdge: 800, quality: 0.65 },
    { maxEdge: 640, quality: 0.58 },
  ];

  let lastDataUrl = null;

  for (const attempt of attempts) {
    lastDataUrl = renderDataUrl(image, attempt.maxEdge, attempt.quality);
    if (lastDataUrl.length <= TARGET_MAX_CHARS) {
      return lastDataUrl;
    }
  }

  return lastDataUrl;
}
